/**
 * @generated SignedSource<<6c210e8b6e67913f30c2d1a9eedbd636>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView$data = {
  readonly selectedVersionsConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView";
};
export type multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView$key = {
  readonly " $data"?: multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "multiVersionPicker_issueFieldMultiVersionPickerReadviewFull_MultiVersionPickerReadView",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    }
  ],
  "type": "JiraMultipleVersionPickerField"
};

(node as any).hash = "7940aec048cb5cd7c9f0feb1ad306f48";

export default node;
